// extracted by mini-css-extract-plugin
export default {"container":"PlotWeaveMenu_container__XK4xA","logoButton":"PlotWeaveMenu_logoButton__OmoxU","menu":"PlotWeaveMenu_menu__mmcrs"};